import * as api from "../Api";
export const getAllReceipts = () => async (dispatch) => {
  try {
    const { data } = await api.getReceipt();
    dispatch({ type: "GET_ALL_RECEIPT", payload: data });
  } catch (error) {}
};
